export default class Agegate {
 agegateVisible: boolean = false;
 visibleClass: string = 'agegate-visible';
 on: any = {
     hide: new CustomEvent('onHideAgegate')
 }

 constructor() {
     this.observer()
 }

 observer(): void {
     const options = { attributes: true }
     const observer = new MutationObserver((mutations, observer) => {
         mutations.forEach((mutation) => {
             const element = mutation.target as HTMLElement;
             switch (mutation.type) {
                 case 'attributes':
                     if (this.agegateVisible && !element.classList.contains(`${this.visibleClass}`)) {
                         setTimeout(() => {
                             window.dispatchEvent(this.on.hide)
                         }, 200)
                         observer.disconnect();
                     }
                     else {
                         this.agegateVisible = element.classList.contains(`${this.visibleClass}`)
                     }
                     break;
                 default:
                     break;
             }
         })
     })

     observer.observe(document.body, options)
 }

 isAgegateVisible(): boolean {
     return this.agegateVisible
 }
}